import { BaseAPI } from './BaseAPI.js'
import { Callback } from '../types/index.js'

export default class CallbacksAPI extends BaseAPI<Callback> {
  override get resource(): string {
    return '/callbacks'
  }
}
